import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Container from './style'

interface Props {
  children: ReactNode | string
  onPress?: () => void
  isDisabled?: boolean
  isPrimary?: boolean
  usePrimaryColor?: boolean
  type?: 'button' | 'submit' | 'reset'
  style?: CSSProperties
  className?: string
  id?: string
}

function Button({
  id,
  children,
  onPress,
  className,
  style,
  type,
  isDisabled,
  isPrimary,
  usePrimaryColor,
}: Props): ReactElement {
  return (
    <Container
      id={id}
      className={`${className} ${!isPrimary ? 'secondary-type' : ''} ${
        !usePrimaryColor ? 'secondary-color' : ''
      }`}
      onClick={onPress}
      style={style}
      type={type}
      aria-label={typeof children === 'string' ? children : 'button'}
      disabled={isDisabled}
    >
      {children}
    </Container>
  )
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  isDisabled: PropTypes.bool,
  isPrimary: PropTypes.bool,
  usePrimaryColor: PropTypes.bool,
  onPress: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
}

Button.defaultProps = {
  isDisabled: false,
  isPrimary: true,
  usePrimaryColor: true,
  className: '',
  type: 'button',
}

export default memo(Button)
